import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const Sidebar = () => {
    const environment = process.env.REACT_APP_ENVIRONMENT;

    if (!environment) {
        throw new Error("Environment was not specified");
    } else if (environment !== "production" && environment !== "test") {
        throw new Error(`Invalid environment ${environment}`);
    }
    const privileges = secureLocalStorage.getItem("privileges");
    const bridgeConsolePrivileges = [
        "bridge_console",
        "bridge_console_audit_logs",
        "bridge_console_error_logs",
        "bridge_console_roles",
        "bridge_console_notifications",
        "bridge_console_notification_config",
    ];
    const canViewBridgeConsole =
        bridgeConsolePrivileges.some((privilege) =>
            privileges.includes(privilege)
        );
    const canViewNotificationConsole =
        privileges.includes("bridge_console_notifications") ||
        privileges.includes("bridge_console_notification_config");
    const canViewLiveSite =
        privileges.includes("live_site_retrieve") ||
        privileges.includes("live_site_update");
    const canViewTestCases = privileges.includes("test_case");
    const canViewOnsiteIssues = privileges.includes("onsite_issue");
    const canViewFloorData = privileges.includes("floor_data_retrieve");
    const location = useLocation();

    const [sidebarActive, setSidebarActive] = useState(false);
    const handleActive = (status) => {
        setSidebarActive(status);
    };

    const [sidebarMasterActive, setSidebarMasterActive] = useState(false);
    const [processFlowActive, setProcessFlowActive] = useState(false);
    const [requisitionActive, setRequisitionActive] = useState(false);
    const [dashboardActive, setDashboardActive] = useState(false);
    const [inventoryManagement, setInventoryManagement] = useState(false);
    const [qualityCheck, setQualityCheck] = useState(false);
    const [statusCheck, setStatusCheck] = useState(false);
    const handleMasterActive = (status) => {
        setSidebarMasterActive(status);
    };

    return (
        <>
            <div
                className="nk-sidebar is-light nk-sidebar-fixed is-light"
                data-content="sidebarMenu"
            >
                {environment === "test" ? (
                    <div className="ribbon">
                        <span>Test</span>
                    </div>
                ) : null}
                <div className="nk-sidebar-element nk-sidebar-head">
                    <div className="nk-sidebar-brand">
                        <a
                            href="javascript:void(0)"
                            className="logo-link nk-sidebar-logo"
                        >
                            <img
                                className="logo-light logo-img"
                                src="./assets/images/gev-logo-dark.png"
                                srcSet="./assets/images/gev-logo-dark.png 2x"
                                alt="gev-logo"
                            />
                            <img
                                className="logo-dark logo-img"
                                src="./assets/images/gev-logo-dark.png"
                                srcSet="./assets/images/gev-logo-dark.png 2x"
                                alt="gev-logo"
                            />
                            <img
                                className="logo-small logo-img logo-img-small"
                                src="./assets/images/gev-logo-dark.png"
                                srcSet="./assets/images/gev-logo-dark.png 2x"
                                alt="gev-logo"
                            />
                        </a>
                    </div>
                    <div className="nk-menu-trigger me-n2">
                        <a
                            href="#"
                            className="nk-nav-toggle nk-quick-nav-icon d-xl-none"
                            data-target="sidebarMenu"
                        >
                            <em className="icon ni ni-arrow-left"></em>
                        </a>
                    </div>
                </div>

                {/* <!-- .nk-sidebar-element --> */}
                <div className="nk-sidebar-element">
                    <div className="nk-sidebar-content">
                        <div className="nk-sidebar-menu" data-simplebar>
                            <ul className="nk-menu">
                                {["statistics_dashboard"].some((privilege) =>
                                    privileges.includes(privilege)
                                ) && (
                                    <li
                                        className={`${
                                            dashboardActive
                                                ? "nk-menu-item has-sub active"
                                                : "nk-menu-item has-sub"
                                        }`}
                                    >
                                        <a
                                            href="javascript:void(0)"
                                            className="nk-menu-link nk-menu-toggle"
                                            onClick={() =>
                                                setDashboardActive(
                                                    !dashboardActive
                                                )
                                            }
                                            id="sidebar-setting"
                                        >
                                            <span className="nk-menu-icon">
                                                <em class="icon ni ni-activity-round"></em>
                                            </span>
                                            <span className="nk-menu-text">
                                                Dashboards
                                            </span>
                                        </a>
                                        <ul className="nk-menu-sub">
                                            {privileges.includes(
                                                "statistics_dashboard"
                                            ) && (
                                                <li className="nk-menu-item">
                                                    <NavLink
                                                        to="/"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Dashboard
                                                        </span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {privileges.includes(
                                                "work_order_check"
                                            ) && (
                                                <li className="nk-menu-item">
                                                    <NavLink
                                                        to="/requirement-analysis"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Requirement Analysis
                                                        </span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {privileges.includes(
                                                "batch_insights"
                                            ) && (
                                                <li className="nk-menu-item">
                                                    <NavLink
                                                        to="/batch-insights"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Batch Insights
                                                        </span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {privileges.includes(
                                                "sales_order_insights"
                                            ) && (
                                                <li className="nk-menu-item">
                                                    <NavLink
                                                        to="/sales-order-insights"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Sales Order Insights
                                                        </span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "job-cards"
                                                ) && (
                                                    <NavLink
                                                        to="/job-cards"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Job Cards
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "machine_operator_association"
                                                ) && (
                                                    <NavLink
                                                        to="/machine-operator-association"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Machine Operation
                                                            Association
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "machine_dashboard"
                                                ) && (
                                                    <NavLink
                                                        to="/machine-dashboard"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Machine Dashboard
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "machine_dashboard_support"
                                                ) && (
                                                    <NavLink
                                                        to="/machine-dashboard-support"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Machine Dashboard
                                                            Support
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "power_consumption_dashboard"
                                                ) && (
                                                    <NavLink
                                                        to="/power-consumption-dashboard"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Power Consumption
                                                            Dashboard
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                        </ul>
                                    </li>
                                )}

                                {/* To-Do: Add privilege */}
                                {privileges.includes("inventory") && (
                                    <li className="nk-menu-item">
                                        <NavLink
                                            to="/inventory"
                                            className="nk-menu-link"
                                        >
                                            <span className="nk-menu-icon">
                                                <em className="icon ni ni-tag"></em>
                                            </span>
                                            <span className="nk-menu-text">
                                                Inventory
                                            </span>
                                        </NavLink>
                                    </li>
                                )}

                                {[
                                    "sales_order_retrieve",
                                    "sales_order_create",
                                    "sales_order_update",
                                    "sales_order_delete",
                                    "work_order_split",
                                    "approve_sales_order",
                                    "work_order_retrieve",
                                    "work_order_create",
                                    "work_order_update",
                                    "work_order_delete",
                                    "daily_plan",
                                    "raise_requisition",
                                    "store_dept_slip_update",
                                    "sales_order_dispatch",
                                ].some((privilege) =>
                                    privileges.includes(privilege)
                                ) && (
                                    <li
                                        className={`${
                                            processFlowActive
                                                ? "nk-menu-item has-sub active"
                                                : "nk-menu-item has-sub"
                                        }`}
                                    >
                                        <a
                                            href="javascript:void(0)"
                                            className="nk-menu-link nk-menu-toggle"
                                            onClick={() =>
                                                setProcessFlowActive(
                                                    !processFlowActive
                                                )
                                            }
                                            id="sidebar-setting"
                                        >
                                            <span className="nk-menu-icon">
                                                <em class="icon ni ni-network"></em>
                                            </span>
                                            <span className="nk-menu-text">
                                                Process flow
                                            </span>
                                        </a>
                                        <ul className="nk-menu-sub">
                                            <li className="nk-menu-item">
                                                {[
                                                    "sales_order_retrieve",
                                                    "sales_order_create",
                                                    "sales_order_update",
                                                    "sales_order_delete",
                                                    "work_order_split",
                                                    "approve_sales_order",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/sales-order?q=2&c=activity_status"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Sales Order
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {[
                                                    "work_order_retrieve",
                                                    "work_order_create",
                                                    "work_order_update",
                                                    "work_order_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/work-order"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Work Order
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "machine_shift_association"
                                                ) && (
                                                    <NavLink
                                                        to="/machine-shift-association"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Machine Shift
                                                            Association
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "daily_plan"
                                                ) && (
                                                    <NavLink
                                                        to="/daily-plan"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Daily Plan
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>

                                            {[
                                                "raise_requisition",
                                                "store_dept_slip_update",
                                            ].some((privilege) =>
                                                privileges.includes(privilege)
                                            ) && (
                                                <li
                                                    className={`${
                                                        requisitionActive
                                                            ? "nk-menu-item has-sub active"
                                                            : "nk-menu-item has-sub"
                                                    }`}
                                                >
                                                    <a
                                                        href="javascript:void(0)"
                                                        className="nk-menu-link nk-menu-toggle"
                                                        onClick={() =>
                                                            setRequisitionActive(
                                                                !requisitionActive
                                                            )
                                                        }
                                                        id="sidebar-setting"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Requisition
                                                        </span>
                                                    </a>
                                                    <ul className="nk-menu-sub">
                                                        <li className="nk-menu-item">
                                                            {privileges.includes(
                                                                "raise_requisition"
                                                            ) && (
                                                                <NavLink
                                                                    to="/raise-requisition"
                                                                    className="nk-menu-link"
                                                                >
                                                                    <span className="nk-menu-text">
                                                                        Raise
                                                                        Requisition
                                                                    </span>
                                                                </NavLink>
                                                            )}
                                                        </li>

                                                        <li className="nk-menu-item">
                                                            {privileges.includes(
                                                                "store_dept_slip_update"
                                                            ) && (
                                                                <NavLink
                                                                    to="/issue-stock"
                                                                    className="nk-menu-link"
                                                                >
                                                                    <span className="nk-menu-text">
                                                                        Issue
                                                                        Stock
                                                                    </span>
                                                                </NavLink>
                                                            )}
                                                        </li>

                                                        <li className="nk-menu-item">
                                                            {privileges.includes(
                                                                "returned_slip"
                                                            ) && (
                                                                <NavLink
                                                                    to="/return-slip"
                                                                    className="nk-menu-link"
                                                                >
                                                                    <span className="nk-menu-text">
                                                                        Return
                                                                        Slip
                                                                    </span>
                                                                </NavLink>
                                                            )}
                                                        </li>
                                                    </ul>
                                                </li>
                                            )}
                                            {/* To-Do: Add privilege */}

                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "sales_order_dispatch"
                                                ) && (
                                                    <NavLink
                                                        to="/dispatch-sales-order?q=1,6&c=activity_status"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Dispatched Orders
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                        </ul>
                                    </li>
                                )}

                                {[
                                    "item_retrieve",
                                    "item_create",
                                    "item_update",
                                    "item_delete",
                                    "bom_retrieve",
                                    "bom_create",
                                    "bom_update",
                                    "bom_delete",
                                    "simulate_bom",
                                    "stock_transaction_retrieve",
                                    "stock_onboarding_import",
                                    "raise_purchase_order",
                                ].some((privilege) =>
                                    privileges.includes(privilege)
                                ) && (
                                    <li
                                        className={`${
                                            inventoryManagement
                                                ? "nk-menu-item has-sub active"
                                                : "nk-menu-item has-sub"
                                        }`}
                                    >
                                        <a
                                            href="javascript:void(0)"
                                            className="nk-menu-link nk-menu-toggle"
                                            onClick={() =>
                                                setInventoryManagement(
                                                    !inventoryManagement
                                                )
                                            }
                                            id="sidebar-setting"
                                        >
                                            <span className="nk-menu-icon">
                                                <em class="icon ni ni-list-index-fill"></em>
                                            </span>
                                            <span className="nk-menu-text">
                                                Inventory management
                                            </span>
                                        </a>
                                        <ul className="nk-menu-sub">
                                            <li className="nk-menu-item">
                                                {[
                                                    "item_retrieve",
                                                    "item_create",
                                                    "item_update",
                                                    "item_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/item"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Item
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {[
                                                    "bom_retrieve",
                                                    "bom_create",
                                                    "bom_update",
                                                    "bom_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/bom"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            BOM
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {["simulate_bom"].some(
                                                    (privilege) =>
                                                        privileges.includes(
                                                            privilege
                                                        )
                                                ) && (
                                                    <NavLink
                                                        to="/simulate-bom"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Simulate BOM
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "stock_transaction_retrieve"
                                                ) && (
                                                    <NavLink
                                                        to="/stock-transaction"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Transactions
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "stock_transaction_retrieve"
                                                ) && (
                                                    <NavLink
                                                        to="/stock-ledger"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Stock Ledger
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "stock_onboarding_import"
                                                ) && (
                                                    <NavLink
                                                        to="/stock-onboarding"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Stock Onboarding
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "raise_purchase_order"
                                                ) && (
                                                    <NavLink
                                                        to="/purchase-order"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Purchase orders
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                        </ul>
                                    </li>
                                )}

                                {[
                                    "qc_screen",
                                    "qc_report",
                                    "qc_previous_report",
                                ].some((privilege) =>
                                    privileges.includes(privilege)
                                ) && (
                                    <li
                                        className={`${
                                            qualityCheck
                                                ? "nk-menu-item has-sub active"
                                                : "nk-menu-item has-sub"
                                        }`}
                                    >
                                        <a
                                            href="javascript:void(0)"
                                            className="nk-menu-link nk-menu-toggle"
                                            onClick={() =>
                                                setQualityCheck(!qualityCheck)
                                            }
                                            id="sidebar-setting"
                                        >
                                            <span className="nk-menu-icon">
                                                <em class="icon ni ni-check-circle-fill"></em>
                                            </span>
                                            <span className="nk-menu-text">
                                                Quality check
                                            </span>
                                        </a>
                                        <ul className="nk-menu-sub">
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "qc_screen"
                                                ) && (
                                                    <NavLink
                                                        to="/item-selection"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Initiate QC
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            {/* <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "qc_previous_report"
                                                ) && (
                                                    <NavLink
                                                        to="/qc-previous-report-select"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Previous Reports
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "qc_report"
                                                ) && (
                                                    <NavLink
                                                        to="/qc-report-select"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            QC report
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li> */}
                                            <li className="nk-menu-item">
                                                {/* To-Do: Add privilege */}
                                                {privileges.includes(
                                                    "qc-details"
                                                ) && (
                                                    <NavLink
                                                        to="/qc-details"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            QC details
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                        </ul>
                                    </li>
                                )}

                                {[
                                    "delivery_status",
                                    "machine_status_retrieve",
                                    "item_status",
                                    "daily_production",
                                ].some((privilege) =>
                                    privileges.includes(privilege)
                                ) && (
                                    <li
                                        className={`${
                                            statusCheck
                                                ? "nk-menu-item has-sub active"
                                                : "nk-menu-item has-sub"
                                        }`}
                                    >
                                        <a
                                            href="javascript:void(0)"
                                            className="nk-menu-link nk-menu-toggle"
                                            onClick={() =>
                                                setStatusCheck(!statusCheck)
                                            }
                                            id="sidebar-setting"
                                        >
                                            <span className="nk-menu-icon">
                                                <em class="icon ni ni-loader"></em>
                                            </span>
                                            <span className="nk-menu-text">
                                                Status
                                            </span>
                                        </a>
                                        <ul className="nk-menu-sub">
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "delivery_status"
                                                ) && (
                                                    <NavLink
                                                        to="/delivery-status?q=0&c=activity_status"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Delivery Status
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "item_status"
                                                ) && (
                                                    <NavLink
                                                        to="/item-status"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Item Status
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {[
                                                    "machine_status_retrieve",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/machine-status"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Machine Status
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {["daily_production"].some(
                                                    (privilege) =>
                                                        privileges.includes(
                                                            privilege
                                                        )
                                                ) && (
                                                    <NavLink
                                                        to="/daily-production"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Daily Production
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                        </ul>
                                    </li>
                                )}

                                {privileges.includes("master") && (
                                    <li
                                        className={`${
                                            sidebarMasterActive
                                                ? "nk-menu-item has-sub active"
                                                : "nk-menu-item has-sub"
                                        }`}
                                    >
                                        <a
                                            href="javascript:void(0)"
                                            className="nk-menu-link nk-menu-toggle"
                                            onClick={() =>
                                                handleMasterActive(
                                                    !sidebarMasterActive
                                                )
                                            }
                                            id="sidebar-setting"
                                        >
                                            <span className="nk-menu-icon">
                                                <em className="icon ni ni-external"></em>
                                            </span>
                                            <span className="nk-menu-text">
                                                Master
                                            </span>
                                        </a>
                                        <ul className="nk-menu-sub">
                                            <li className="nk-menu-item">
                                                {[
                                                    "client_retrieve",
                                                    "client_create",
                                                    "client_update",
                                                    "client_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/client"
                                                        className="nk-menu-link"
                                                    >
                                                        {/* <span className="nk-menu-icon">
                              <em className="icon ni ni-users"></em>
                            </span> */}
                                                        <span className="nk-menu-text">
                                                            Client
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {[
                                                    "supplier_retrieve",
                                                    "supplier_create",
                                                    "supplier_update",
                                                    "supplier_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/supplier"
                                                        className="nk-menu-link"
                                                    >
                                                        {/* <span className="nk-menu-icon">
                              <em className="icon ni ni-card-view"></em>
                            </span> */}
                                                        <span className="nk-menu-text">
                                                            Supplier
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            {/* <li className="nk-menu-item">
                                                {[
                                                    "client_item_retrieve",
                                                    "client_item_create",
                                                    "client_item_update",
                                                    "client_item_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/client-item"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-icon">
                              <em className="icon ni ni-card-view"></em>
                            </span>
                                                        <span className="nk-menu-text">
                                                            Client-Item
                                                            Association
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li> */}
                                            {/* <li className="nk-menu-item">
                                                {[
                                                    "supplier_item_retrieve",
                                                    "supplier_item_create",
                                                    "supplier_item_update",
                                                    "supplier_item_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/supplier-item"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-icon">
                              <em className="icon ni ni-card-view"></em>
                            </span>
                                                        <span className="nk-menu-text">
                                                            Supplier-Item
                                                            Association
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li> */}
                                            <li className="nk-menu-item">
                                                {[
                                                    "operator_retrieve",
                                                    "operator_create",
                                                    "operator_update",
                                                    "operator_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/operator"
                                                        className="nk-menu-link"
                                                    >
                                                        {/* <span className="nk-menu-icon">
                              <em class="icon ni ni-newspaper"></em>
                            </span> */}
                                                        <span className="nk-menu-text">
                                                            Operator
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            {/* <li className="nk-menu-item">
                                                {[
                                                    "daily_production_retrieve",
                                                    "daily_production_create",
                                                    "daily_production_update",
                                                    "daily_production_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/daily-production-report"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-icon">
                              <em class="icon ni ni-newspaper"></em>
                            </span>
                                                        <span className="nk-menu-text">
                                                            Daily production
                                                            report
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li> */}
                                            <li className="nk-menu-item">
                                                {[
                                                    "machine_retrieve",
                                                    "machine_create",
                                                    "machine_update",
                                                    "machine_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/machine"
                                                        className="nk-menu-link"
                                                    >
                                                        {/* <span className="nk-menu-icon">
                              <em className="icon ni ni-card-view"></em>
                            </span> */}
                                                        <span className="nk-menu-text">
                                                            Machine
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {[
                                                    "bo_retrieve",
                                                    "bo_create",
                                                    "bo_update",
                                                    "bo_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/bo"
                                                        className="nk-menu-link"
                                                    >
                                                        {/* <span className="nk-menu-icon">
                              <em class="icon ni ni-newspaper"></em>
                            </span> */}
                                                        <span className="nk-menu-text">
                                                            BO
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            {/* <li className="nk-menu-item">
                                                {[
                                                    "sampling_plan_retrieve",
                                                    "sampling_plan_create",
                                                    "sampling_plan_update",
                                                    "sampling_plan_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/operator"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-icon">
                              <em class="icon ni ni-newspaper"></em>
                            </span>
                                                        <span className="nk-menu-text">
                                                            Operator
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li> */}

                                            <li className="nk-menu-item">
                                                {[
                                                    "quality_parameter_retrieve",
                                                    "quality_parameter_create",
                                                    "quality_parameter_update",
                                                    "quality_parameter_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/quality-parameter"
                                                        className="nk-menu-link"
                                                    >
                                                        {/* <span className="nk-menu-icon">
                              <em className="icon ni ni-tranx"></em>
                            </span> */}
                                                        <span className="nk-menu-text">
                                                            Quality Parameter
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>

                                            <li className="nk-menu-item">
                                                {[
                                                    "quality_rules_retrieve",
                                                    "quality_rules_create",
                                                    "quality_rules_update",
                                                    "quality_rules_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/quality-rules"
                                                        className="nk-menu-link"
                                                    >
                                                        {/* <span className="nk-menu-icon">
                              <em className="icon ni ni-tranx"></em>
                            </span> */}
                                                        <span className="nk-menu-text">
                                                            Quality Rules
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>

                                            {/* <li className="nk-menu-item">
                                                {[
                                                    "quality_check_retrieve",
                                                    "quality_check_create",
                                                    "quality_check_update",
                                                    "quality_check_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/quality-check"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-icon">
                              <em className="icon ni ni-tranx"></em>
                            </span>
                                                        <span className="nk-menu-text">
                                                            Quality Check result
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li> */}

                                            {/* <li className="nk-menu-item">
                                                {[
                                                    "quality_rule_association_retrieve",
                                                    "quality_rule_association_create",
                                                    "quality_rule_association_update",
                                                    "quality_rule_association_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/quality-rule-association"
                                                        className="nk-menu-link"
                                                    >
                                                        <span className="nk-menu-icon">
                              <em className="icon ni ni-tranx"></em>
                            </span>
                                                        <span className="nk-menu-text">
                                                            Quality Parameter
                                                            Rule Association
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li> */}
                                        </ul>
                                        {/* <!-- .nk-menu-sub --> */}
                                    </li>
                                )}

                                {(privileges.includes("setting") ||
                                    privileges.includes("reports") ||
                                    canViewLiveSite ||
                                    canViewTestCases ||
                                    canViewOnsiteIssues ||
                                    canViewFloorData ||
                                    canViewBridgeConsole) && (
                                    <li
                                        className={`${
                                            sidebarActive
                                                ? "nk-menu-item has-sub active"
                                                : "nk-menu-item has-sub"
                                        }`}
                                    >
                                        <a
                                            href="javascript:void(0)"
                                            className="nk-menu-link nk-menu-toggle"
                                            onClick={() =>
                                                handleActive(!sidebarActive)
                                            }
                                            id="sidebar-setting"
                                        >
                                            <span className="nk-menu-icon">
                                                <em className="icon ni ni-setting"></em>
                                            </span>
                                            <span className="nk-menu-text">
                                                Settings
                                            </span>
                                        </a>
                                        <ul className="nk-menu-sub">
                                            <li className="nk-menu-item">
                                                {[
                                                    "privilege_retrieve",
                                                    "privilege_create",
                                                    "privilege_update",
                                                    "privilege_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/privilege"
                                                        className="nk-menu-link"
                                                        id="sidebar-privilege"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Privileges
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {[
                                                    "role_retrieve",
                                                    "role_create",
                                                    "role_update",
                                                    "role_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/role"
                                                        className="nk-menu-link"
                                                        id="sidebar-role"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Role
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {["rv_matrix"].some(
                                                    (privilege) =>
                                                        privileges.includes(
                                                            privilege
                                                        )
                                                ) && (
                                                    <NavLink
                                                        to="/rv-matrix"
                                                        className="nk-menu-link"
                                                        id="sidebar-role"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Role Visibility
                                                            Matrix
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {["rv_matrix_updated"].some(
                                                    (privilege) =>
                                                        privileges.includes(
                                                            privilege
                                                        )
                                                ) && (
                                                    <NavLink
                                                        to="/updated-rv-matrix"
                                                        className="nk-menu-link"
                                                        id="sidebar-role"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Updated Role
                                                            Visibility Matrix
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {["rv_matrix_analytics"].some(
                                                    (privilege) =>
                                                        privileges.includes(
                                                            privilege
                                                        )
                                                ) && (
                                                    <NavLink
                                                        to="/rv-analytics"
                                                        className="nk-menu-link"
                                                        id="sidebar-role"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Role Visibility
                                                            analytics
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {canViewBridgeConsole && (
                                                    <NavLink
                                                        to="/bridge-console"
                                                        className="nk-menu-link"
                                                        id="sidebar-bridge-console"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Bridge Console
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {canViewNotificationConsole && (
                                                    <NavLink
                                                        to="/notification-console"
                                                        className="nk-menu-link"
                                                        id="sidebar-notification-console"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Notification Console
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {privileges.includes(
                                                    "reports"
                                                ) && (
                                                    <NavLink
                                                        to="/reports"
                                                        className="nk-menu-link"
                                                        id="sidebar-reports"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Reports
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {canViewLiveSite && (
                                                    <NavLink
                                                        to="/live-site"
                                                        className="nk-menu-link"
                                                        id="sidebar-live-site"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Live Site
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            {/* <li className="nk-menu-item">
                                                {[
                                                    "type_master_retrieve",
                                                    "type_master_create",
                                                    "type_master_update",
                                                    "type_master_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/type-master"
                                                        className="nk-menu-link"
                                                        id="sidebar-type-master"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Type Master
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li> */}
                                            <li className="nk-menu-item">
                                                {[
                                                    "type_master_category_retrieve",
                                                    "type_master_category_create",
                                                    "type_master_category_update",
                                                    "type_master_category_delete",
                                                ].some((privilege) =>
                                                    privileges.includes(
                                                        privilege
                                                    )
                                                ) && (
                                                    <NavLink
                                                        to="/type-master-category"
                                                        className="nk-menu-link"
                                                        id="sidebar-type-master-category"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Type Master Category
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {canViewTestCases && (
                                                    <NavLink
                                                        to="/test-cases"
                                                        className="nk-menu-link"
                                                        id="sidebar-test-cases"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Test Cases
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            <li className="nk-menu-item">
                                                {canViewOnsiteIssues && (
                                                    <NavLink
                                                        to="/onsite-issues"
                                                        className="nk-menu-link"
                                                        id="sidebar-onsite-issues"
                                                    >
                                                        <span className="nk-menu-text">
                                                            On-site Issues
                                                        </span>
                                                    </NavLink>
                                                )}
                                            </li>
                                            {canViewFloorData && (
                                                <li className="nk-menu-item">
                                                    <NavLink
                                                        to="/floor-data"
                                                        className="nk-menu-link"
                                                        id="sidebar-floor-data"
                                                    >
                                                        <span className="nk-menu-text">
                                                            Floor Data
                                                        </span>
                                                    </NavLink>
                                                </li>
                                            )}
                                        </ul>
                                        {/* <!-- .nk-menu-sub --> */}
                                    </li>
                                )}
                                {/* <!-- .nk-menu-item --> */}
                            </ul>
                            {/* <!-- .nk-menu --> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sidebar;
